module.exports = __webpack_public_path__ + "static/media/tow.5b655cac.jpg";